import "./styles.scoped.css";
export default {
    "root": "awsui_root_12hwc_12ujv_5",
    "layout-strut": "awsui_layout-strut_12hwc_12ujv_9",
    "list-bottom": "awsui_list-bottom_12hwc_12ujv_15"
};
